import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../../../node_modules/plyr/dist/plyr.css';
import { ErrorPage, MainContainer } from '@monorepo/shared/src/components/layout';
import { routes } from 'routes';

const registerPageView = (path: string): void => {
  try {
    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({ event: 'Pageview', pagePath: path });
  } catch {
    return;
  }
};

const Wrapper = ({ path, component: Component, ...props }) => {
  registerPageView(props.path);

  return (
    <MainContainer {...props} backgroundColor={'white'}>
      <Component {...props} />
    </MainContainer>
  );
};

const formattedRoutes = routes.map(({ path, component, children, action, ...props }) => ({
  path,
  element: <Wrapper component={component} {...props} path={path} />,
  children,
  action,
}));

// using createBrowserRouter in order to use useBlocker for the RouteGuard
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: formattedRoutes,
  },
  {
    path: '/oops',
    element: <ErrorPage />,
  },
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
